var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("payment-gateway", {
        ref: "paymentGateway",
        attrs: {
          toolbar: _vm.toolbar,
          paypal: _vm.paypal,
          compact: _vm.compact
        },
        on: {
          gateway: _vm.listenGateway,
          card: _vm.listenCard,
          "card-switch": _vm.listenCardNew,
          close: _vm.closeModal
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function fn() {
              return [_vm._v("Invoice Payment")]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      secondary: ""
                    },
                    on: {
                      click: _vm.closeModal
                    }
                  },
                  [_vm._v(" Cancel ")]
                ),
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      primary: "",
                      loading: _vm.payment_loading
                    },
                    on: {
                      click: _vm.makePayment
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.payBtnTitle) + " ")]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm.gateway === "paypal"
        ? _c(
            "form",
            {
              ref: "frm_paypal",
              staticStyle: {
                display: "none"
              },
              attrs: {
                method: "post"
              }
            },
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "cmd",
                  value: "_s-xclick"
                }
              }),
              _c("input", {
                ref: "paypal_encrypted",
                attrs: {
                  type: "text",
                  name: "encrypted"
                }
              }),
              _c("input", {
                attrs: {
                  type: "submit",
                  value: ""
                }
              })
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }